var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgUpgrade = function SvgUpgrade(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.0227V8.90282C7 8.67478 7.11875 8.50375 7.35625 8.38973L16.5 4L25.6437 8.38973C25.8812 8.50375 26 8.67478 26 8.90282V12.0227C26 12.4218 25.5844 12.7069 25.1688 12.5358L16.5 8.37414L7.83125 12.5358C7.475 12.7069 7 12.4218 7 12.0227Z",
    fill: "#88898F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.6117V19.7316C7 20.1307 7.475 20.4157 7.83125 20.2447L16.5 16.083L25.1688 20.2447C25.5844 20.4157 26 20.1307 26 19.7316V16.6117C26 16.3836 25.8812 16.2126 25.6437 16.0986L16.5 11.7089L7.35625 16.0986C7.11875 16.2126 7 16.3836 7 16.6117Z",
    fill: "#88898F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 24.3164V27.4363C7 27.8353 7.475 28.1204 7.83125 27.9494L16.5 23.7877L25.1688 27.9494C25.5844 28.1204 26 27.8353 26 27.4363V24.3163C26 24.0883 25.8812 23.9173 25.6437 23.8033L16.5 19.4135L7.35625 23.8033C7.11875 23.9173 7 24.0883 7 24.3164Z",
    fill: "#88898F"
  })));
};
export default SvgUpgrade;